import React from "react";

const NewDepartmentForm = ({ onSubmit, onCancel }) => {
	const nameRef = React.createRef();
	return (
		<form
			method="POST"
			onSubmit={event => {
				event.preventDefault();
				const name = nameRef.current.value;
				onSubmit(name);
				nameRef.current.value = "";
			}}
		>
			<div className="form-group">
				<label htmlFor="nameInput">Name</label>
				<input
					type="text"
					className="form-control input-height"
					id="nameInput"
					required
					ref={nameRef}
					aria-describedby="Name"
					placeholder="Enter name"
				/>
				<small id="nameInput" className="form-text text-muted">
					Leave type is required.
				</small>
			</div>
			<div className="text-center">
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default"
				>
					<i className="material-icons text-danger">cancel</i> Cancel
				</button>

				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success"
				>
					Submit <i className="material-icons">arrow_right_alt</i>
				</button>
			</div>
		</form>
	);
};

export default NewDepartmentForm;
